// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".f04ec786be2629139b5d60d74901063661f3dd74.chunk.bundle.js";
};